import React from 'react'
import { createRoot } from 'react-dom/client'
import { ApolloProvider, useQuery } from '@apollo/client'
import client from '../client'
import fetchOutstandingCount from '../queries/outstanding-count'
import { sum } from 'ramda'

function OutstandingCount() {
  const { loading, error, data } = useQuery(fetchOutstandingCount)

  if (loading) return <div>loading...</div>
  if (error) return <div>error :(</div>

  const count =
    data &&
    data.projects &&
    sum(data.projects.map((p) => p.outstandingAssignments.length))

  if (count && count > 0) {
    return <div className="badge">{count}</div>
  } else {
    return null
  }
}

const outstandingCount = document.getElementById('outstanding-count')
if (outstandingCount) {
  const root = createRoot(outstandingCount)
  root.render(
    <ApolloProvider client={client}>
      <OutstandingCount />
    </ApolloProvider>
  )
}
